import request, { endpoint } from './request';

// Responses

export function getResponses(formID) {
  return request({
    path: `/v1/responses?form_id=${formID}`,
  });
}

export function deleteResponse(id) {
  return request({
    path: `/v1/responses/${id}`,
    type: 'delete',
  });
}

export function searchResponses(attrs) {
  return request({
    path: `/v1/responses/search`,
    type: 'post',
    json: attrs,
  });
}

export function countResponses(attrs) {
  return request({
    path: `/v1/responses/count`,
    type: 'post',
    json: attrs,
  });
}

export function createResponse(attrs = {}) {
  return request({
    path: `/v1/responses`,
    type: 'post',
    json: attrs,
  });
}

export function getResponseColumns(formID) {
  return request({
    path: `/v1/responses/columns?form_id=${formID}`,
  });
}

export function getAllResponseColumns(formID) {
  return request({
    path: `/v1/responses/columns/all?form_id=${formID}`,
  });
}

export function updateResponseColumns(attrs = {}) {
  return request({
    path: `/v1/responses/columns`,
    type: 'put',
    json: attrs,
  });
}

export function exportResponses(params) {
  window.location = `${endpoint}/v1/responses/csv?form_id=${params.form_id}`;
}
